import { useHistory } from 'react-router-dom'
import { common } from '@ocean/ui'
import { GoToButtonProps } from '@ocean/ui/dist/components/common/GoToButton/types'
import { ReferrerUtils } from 'utils'

const { GoToButton: GoToButtonComponent } = common

const GoToButton: React.FC<GoToButtonProps> = props => {
  const history = useHistory()
  const onClick = props.onClick || handleClick

  function handleClick() {
    ReferrerUtils.historyGoToReferrer(history)
  }

  return <GoToButtonComponent {...props} onClick={onClick} />
}

export default GoToButton
